<template>
  <div class="result">
    <page-header />
    <section class="main">
      <h2 class="title">区域赛报名结果</h2>
      <div class="msg">
        <el-result :icon="auditStatusObj[audit_status].label" :title="auditStatusObj[audit_status].name"></el-result>
        <div class="remark" v-if="audit_status === 1">{{ audit_remark }}</div>
        <div v-if="audit_status === 5">
          <template v-for="item of award_pre_type_config">
            <div class="award" :key="item.id" v-if="item.id === pre_data.award_type">{{ item.name }}
            </div>
          </template>
          <div class="final">
            {{ finalStatusObj[final_status]['name'] }}
          </div>
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" icon="el-icon-tickets" @click="onSeeMsg">查看报名信息</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import { fetchBasic } from '@/service/api'

export default {
  name: 'PageResult',
  components: {
    PageHeader
  },
  data () {
    return {
      basic: {},
      audit_status: 3,
      audit_remark: '',
      auditStatusObj: {
        1: { name: '区域赛审查退回', label: 'error' },
        2: { name: '区域赛审查通过，等待区域赛答辩', label: 'info' },
        3: { name: '区域赛作品未提交', label: 'normal' },
        4: { name: '区域赛作品审查中', label: 'warning' },
        5: { name: '区域赛结束，公布获奖结果', label: 'success' }
      },
      final_status: 3,
      finalStatusObj: {
        1: { name: '未进入决赛' },
        2: { name: '已进入决赛' },
        3: { name: '决赛评审中' }
      },
      award_pre_type_config: [],
      pre_data: {}
    }
  },
  methods: {
    async getBasic () {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      })

      try {
        const data = await fetchBasic()
        this.award_pre_type_config = data.award_pre_type_config
        this.pre_data = data.pre_data
        this.basic = data.team_basic
        this.audit_status = this.basic.audit_status
        this.audit_remark = this.basic.audit_remark
        this.final_status = this.basic.final_status

        loading.close()
      } catch (error) {
        loading.close()
        console.log('getBasic error', error)
      }
    },
    onSeeMsg () {
      this.$router.push('/basic')
    }
  },
  mounted () {
    document.body.style.height = 'auto'
    this.getBasic()
  },
  unmounted () {
    document.body.style.height = '100%'
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
